import * as React from "react";
import { forwardRef } from "react";
const SvgDefault = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "none", fillRule: "evenodd", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M12 2v3.333M12 22v-3.333M4.929 4.929l2.357 2.357m11.785 11.785-2.357-2.356M2 12h3.333M22 12h-3.333M4.929 19.071l2.357-2.356M19.071 4.929l-2.357 2.357" }));
const ForwardRef = forwardRef(SvgDefault);
export { ForwardRef as ReactComponent };
